import { Button } from "@mui/material";

const DialogActionCancel = Button;

export default DialogActionCancel;
